<ng-template pTemplate="header">
  <span class="text-xl font-bold">{{ question_title }}</span>
</ng-template>

<div class="flex gap-1 mb-2">
  <p-chip
    *ngFor="let p of chosenProducts"
    [label]="p.name"></p-chip>
</div>

<div class="grid align-items-center">
  <div class="col-4">
    <span class="p-input-icon-left ml-auto w-full">
      <i class="pi pi-search"></i>
      <input
        pInputText
        type="text"
        class="w-full"
        #keywordFilter
        (input)="
          dt1.filterGlobal(
            [keywordFilter.value, serviceNameFilter.value, idFilter.value?.identifier],
            ''
          )
        "
        placeholder="Cerca per nome..." />
    </span>
  </div>
  <div class="col-4">
    <span class="p-input-icon-left ml-auto w-full">
      <i class="pi pi-search"></i>
      <input
        pInputText
        type="text"
        class="w-full"
        #serviceNameFilter
        (input)="
          dt1.filterGlobal(
            [keywordFilter.value, serviceNameFilter.value, idFilter.value?.identifier],
            ''
          )
        "
        placeholder="Cerca per servizio..." />
    </span>
  </div>
  <div class="col-3">
    <p-autoComplete
      [(ngModel)]="selectedId"
      [suggestions]="filteredService"
      (completeMethod)="filterService($event)"
      field="identifier"
      dataKey="id"
      class="flex-grow-1"
      #idFilter
      (onSelect)="
        dt1.filterGlobal(
          [keywordFilter.value, serviceNameFilter.value, idFilter.value?.identifier],
          ''
        )
      "
      styleClass="w-full"
      placeholder="Filtra per codice servizio..."
      [showClear]="true"></p-autoComplete>
  </div>
  <div class="col">
    <p-button
      styleClass="butt w-full"
      icon="pi pi-filter-slash"
      (click)="clear(dt1)"
      pTooltip="Elimina filtri"
      tooltipPosition="top"></p-button>
  </div>
</div>
<div class="tbl max-w-full">
  <p-table
    [value]="categories"
    dataKey="id"
    #dt1
    [paginator]="true"
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="rowsPerPageOptions"
    [loading]="loading"
    [lazy]="true"
    (onLazyLoad)="loadCats($event)"
    [totalRecords]="totalRecords"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Risultati {first} - {last} di {totalRecords} totali">
    <ng-template
      pTemplate="body"
      let-c
      let-expanded="expanded">
      <tr [ngClass]="expanded ? 'expanded' : ''">
        <td>
          <div class="flex gap-3 align-items-center">
            <button
              type="button"
              pButton
              pRipple
              [pRowToggler]="c"
              class="p-button-text p-button-rounded p-button-plain"
              [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
            <!-- <p-tableCheckbox [value]="c" [pRowToggler]="c"></p-tableCheckbox> -->
            <span>{{ c.name }}</span>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="rowexpansion"
      let-c>
      <p-table
        [value]="c.services"
        [(selection)]="selectedServices"
        dataKey="id">
        <ng-template
          pTemplate="body"
          let-s>
          <tr>
            <td class="expanded">
              <div class="flex align-items-center gap-1 checkbox_service">
                <p-tableCheckbox [value]="s"></p-tableCheckbox>
                <small>{{ s.name }} - {{ s.identifier }}</small>
              </div>
              <!-- <p-chip (click)="showInfo(s, c.id, $event)" class="row-chip single">
                                    <p-tableCheckbox [value]="s"></p-tableCheckbox>
                                    {{s.name}} - {{s.identifier}}
                                </p-chip> -->
            </td>
            <td>
              <input
                pInputText
                type="text"
                class="w-full"
                placeholder="Descrizione*..."
                [disabled]="!isSelected(s)"
                [(ngModel)]="s.description" />
            </td>
            <!-- [(ngModel)]="s.description" -->
          </tr>
        </ng-template>
      </p-table>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td
          colspan="2"
          class="text-center py-2">
          Nessun risultato.
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<div class="modal-footer">
  <div class="flex justify-content-between">
    <p-button
      (onClick)="close()"
      icon="pi pi-times"
      [text]="true"
      styleClass="butt red"
      [rounded]="true"></p-button>
    <p-button
      icon="pi pi-check"
      (onClick)="save()"
      styleClass="butt"
      [rounded]="true"
      [disabled]="selectedServices.length === 0 || !allDescriptionsSet()"></p-button>
  </div>
</div>

<p-dialog
  header="Header"
  [modal]="true"
  [resizable]="false"
  [draggable]="false"
  [(visible)]="visibleModal"
  [style]="{ width: '50vw' }">
  <ng-template pTemplate="header">
    <span class="text-xl font-bold">Dettagli servizio</span>
  </ng-template>
  <div>
    <span>{{ detail?.name }} - Codice: {{ detail?.identifier }}</span>
    <p>{{ detail?.description }}</p>
  </div>
</p-dialog>
